var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import styled from "styled-components";
import gql from "graphql-tag";
import { Query } from "react-apollo";
import * as cx from "classnames";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as uuid from "uuid";
import Loading from "components/shared/Loading";
import Error from "components/shared/Error";
import { PageComponentType } from "components/shared/Page/PageComponent";
import ImageParagraph from "./ImageParagraph";
import Images from "./Images";
import List from "./List";
import Paragraph from "./Paragraph";
import Video from "./Video";
import Patent from "./Patent";
import Table from "./Table";
import Files from "./Files";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  overflow: auto;\n\n  > form {\n    > div {\n      width: 100%;\n      overflow: auto;\n\n      &:not(:first-child) {\n        margin-top: 20px;\n      }\n    }\n\n    > .box {\n      background: #fafafa;\n      padding: 20px;\n      border: 1px solid #777;\n      position: relative;\n\n      > h2 {\n        font-size: 24px;\n        margin-bottom: 10px;\n      }\n\n      > .up-btn {\n        position: absolute;\n        top: 19px;\n        right: 110px;\n        font-size: 12px;\n        color: #bbb;\n        cursor: pointer;\n      }\n\n      > .down-btn {\n        position: absolute;\n        top: 19px;\n        right: 60px;\n        font-size: 12px;\n        color: #bbb;\n        cursor: pointer;\n      }\n\n      > .delete-btn {\n        position: absolute;\n        top: 10px;\n        right: 20px;\n        font-size: 24px;\n        color: #bbb;\n        cursor: pointer;\n      }\n    }\n\n    > .basic-info {\n      > .content {\n        > div {\n          float: left;\n        }\n\n        > .input-list {\n          width: 70%;\n\n          > .input {\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n\n            > label,\n            input {\n              font-size: 18px;\n              line-height: 30px;\n            }\n\n            > input {\n              width: 300px;\n              margin-left: 10px;\n              padding-left: 5px;\n            }\n          }\n        }\n\n        > .button {\n          width: 30%;\n\n          > button {\n            all: unset;\n            box-sizing: border-box;\n            cursor: pointer;\n            width: 100%;\n            height: 100px;\n            text-align: center;\n            font-size: 18px;\n            background: #eee;\n            color: #bbb;\n            border-radius: 10px;\n          }\n\n          > .submittable {\n            background: #36c;\n            color: #fff;\n          }\n        }\n      }\n    }\n\n    > .creation-box {\n      width: 100%;\n      background: #222;\n      padding: 20px;\n      margin-top: 20px;\n      text-align: center;\n\n      > .title {\n        width: 100%;\n        font-size: 24px;\n        color: #fff;\n      }\n\n      > .btns {\n        width: 100%;\n        margin-top: 20px;\n\n        > .btn {\n          all: unset;\n          box-sizing: border-box;\n          cursor: pointer;\n          padding: 20px;\n          font-size: 16px;\n          background: #fff;\n\n          &:not(:first-child) {\n            margin-left: 20px;\n          }\n        }\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  overflow: auto;\n\n  > form {\n    > div {\n      width: 100%;\n      overflow: auto;\n\n      &:not(:first-child) {\n        margin-top: 20px;\n      }\n    }\n\n    > .box {\n      background: #fafafa;\n      padding: 20px;\n      border: 1px solid #777;\n      position: relative;\n\n      > h2 {\n        font-size: 24px;\n        margin-bottom: 10px;\n      }\n\n      > .up-btn {\n        position: absolute;\n        top: 19px;\n        right: 110px;\n        font-size: 12px;\n        color: #bbb;\n        cursor: pointer;\n      }\n\n      > .down-btn {\n        position: absolute;\n        top: 19px;\n        right: 60px;\n        font-size: 12px;\n        color: #bbb;\n        cursor: pointer;\n      }\n\n      > .delete-btn {\n        position: absolute;\n        top: 10px;\n        right: 20px;\n        font-size: 24px;\n        color: #bbb;\n        cursor: pointer;\n      }\n    }\n\n    > .basic-info {\n      > .content {\n        > div {\n          float: left;\n        }\n\n        > .input-list {\n          width: 70%;\n\n          > .input {\n            width: 100%;\n            height: 50px;\n            padding: 10px;\n\n            > label,\n            input {\n              font-size: 18px;\n              line-height: 30px;\n            }\n\n            > input {\n              width: 300px;\n              margin-left: 10px;\n              padding-left: 5px;\n            }\n          }\n        }\n\n        > .button {\n          width: 30%;\n\n          > button {\n            all: unset;\n            box-sizing: border-box;\n            cursor: pointer;\n            width: 100%;\n            height: 100px;\n            text-align: center;\n            font-size: 18px;\n            background: #eee;\n            color: #bbb;\n            border-radius: 10px;\n          }\n\n          > .submittable {\n            background: #36c;\n            color: #fff;\n          }\n        }\n      }\n    }\n\n    > .creation-box {\n      width: 100%;\n      background: #222;\n      padding: 20px;\n      margin-top: 20px;\n      text-align: center;\n\n      > .title {\n        width: 100%;\n        font-size: 24px;\n        color: #fff;\n      }\n\n      > .btns {\n        width: 100%;\n        margin-top: 20px;\n\n        > .btn {\n          all: unset;\n          box-sizing: border-box;\n          cursor: pointer;\n          padding: 20px;\n          font-size: 16px;\n          background: #fff;\n\n          &:not(:first-child) {\n            margin-left: 20px;\n          }\n        }\n      }\n    }\n  }\n"])));
var GET_SUBPAGE = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetSubpage($id: String!) {\n    subpage(id: $id) {\n      id\n      parent\n      name\n      urlName\n      components {\n        id\n        type\n        value {\n          title\n          paragraph\n          images {\n            url\n            description\n          }\n          image {\n            url\n            description\n          }\n          patent {\n            certificateImgUrl\n            applicationNumber\n            registrationNumber\n          }\n          video {\n            url\n            description\n          }\n          list\n          table {\n            rowNumber\n            columnNumber\n            rows {\n              cells\n            }\n          }\n          files\n        }\n      }\n    }\n  }\n"], ["\n  query GetSubpage($id: String!) {\n    subpage(id: $id) {\n      id\n      parent\n      name\n      urlName\n      components {\n        id\n        type\n        value {\n          title\n          paragraph\n          images {\n            url\n            description\n          }\n          image {\n            url\n            description\n          }\n          patent {\n            certificateImgUrl\n            applicationNumber\n            registrationNumber\n          }\n          video {\n            url\n            description\n          }\n          list\n          table {\n            rowNumber\n            columnNumber\n            rows {\n              cells\n            }\n          }\n          files\n        }\n      }\n    }\n  }\n"])));
var UPLOAD_FILE = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation UploadFile($file: Upload!) {\n    uploadFile(file: $file) {\n      path\n    }\n  }\n"], ["\n  mutation UploadFile($file: Upload!) {\n    uploadFile(file: $file) {\n      path\n    }\n  }\n"])));
var UPDATE_SUBPAGE = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation UpdateSubpage($subpage: UpdatingSubpageInput!) {\n    updateSubpage(subpage: $subpage)\n  }\n"], ["\n  mutation UpdateSubpage($subpage: UpdatingSubpageInput!) {\n    updateSubpage(subpage: $subpage)\n  }\n"])));
var Subpage = /** @class */ (function (_super) {
    __extends(Subpage, _super);
    function Subpage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            imageMap: {},
            touched: false,
        };
        _this.update = function (values, client) { return __awaiter(_this, void 0, void 0, function () {
            var id, name, urlName, components, uploadedImageMap, entries, clonedComponents;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.props.id;
                        name = values.name, urlName = values.urlName, components = values.components;
                        return [4 /*yield*/, this.uploadImages(client)];
                    case 1:
                        uploadedImageMap = _a.sent();
                        entries = Object.entries(uploadedImageMap);
                        if (entries.length) {
                            entries.forEach(function (_a) {
                                var idx = _a[0], paths = _a[1];
                                var type = components[idx].type;
                                switch (type) {
                                    case PageComponentType.ImageParagraph: {
                                        components[idx].value.image.url = paths[0];
                                        break;
                                    }
                                    case PageComponentType.Images: {
                                        paths.forEach(function (path, pathIdx) {
                                            if (path) {
                                                components[idx].value.images[pathIdx].url = path;
                                            }
                                        });
                                        break;
                                    }
                                    case PageComponentType.Patent: {
                                        components[idx].value.patent.certificateImgUrl = paths[0];
                                        break;
                                    }
                                    case PageComponentType.Files: {
                                        components[idx].value.files = (components[idx].value.files || []).concat(paths);
                                    }
                                }
                            });
                        }
                        clonedComponents = JSON.parse(JSON.stringify(components));
                        clonedComponents.forEach(function (component) {
                            _this.removeTypenames(component);
                            _this.changeAToB(component, "", null);
                        });
                        return [4 /*yield*/, client.mutate({
                                mutation: UPDATE_SUBPAGE,
                                variables: {
                                    subpage: {
                                        id: id,
                                        name: name,
                                        urlName: urlName,
                                        components: clonedComponents,
                                    },
                                },
                                refetchQueries: [
                                    {
                                        query: GET_SUBPAGE,
                                        variables: {
                                            id: id,
                                        },
                                    },
                                ],
                            })];
                    case 2:
                        _a.sent();
                        window.alert("변경이 반영되었습니다.");
                        this.setState({
                            imageMap: {},
                            touched: false,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.uploadImages = function (client) { return __awaiter(_this, void 0, void 0, function () {
            var imageMap, uploadedImageMap, entries;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageMap = this.state.imageMap;
                        uploadedImageMap = {};
                        entries = Object.entries(imageMap);
                        if (!entries.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(entries.map(function (_a) {
                                var idx = _a[0], files = _a[1];
                                return __awaiter(_this, void 0, void 0, function () {
                                    var _this = this;
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0: return [4 /*yield*/, Promise.all(files.map(function (file, fileIdx) { return __awaiter(_this, void 0, void 0, function () {
                                                    var path;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                if (!file) {
                                                                    return [2 /*return*/];
                                                                }
                                                                return [4 /*yield*/, client.mutate({
                                                                        mutation: UPLOAD_FILE,
                                                                        variables: { file: file },
                                                                    })];
                                                            case 1:
                                                                path = (_a.sent()).data.uploadFile.path;
                                                                if (!uploadedImageMap[idx]) {
                                                                    uploadedImageMap[idx] = [];
                                                                }
                                                                uploadedImageMap[idx][fileIdx] = path;
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }))];
                                            case 1:
                                                _b.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, uploadedImageMap];
                }
            });
        }); };
        _this.removeTypenames = function (object) {
            if (object && object.__typename) {
                delete object.__typename;
                Object.values(object).forEach(function (value) {
                    if (Array.isArray(value)) {
                        value.forEach(function (v) { return _this.removeTypenames(v); });
                    }
                    else if (typeof value === "object") {
                        _this.removeTypenames(value);
                    }
                });
            }
        };
        _this.changeAToB = function (component, a, b) {
            if (component.value.images) {
                component.value.images.forEach(function (image, idx) {
                    if (image.description === a) {
                        component.value.images[idx].description = b;
                    }
                });
            }
            if (component.value.image && component.value.image.description === a) {
                component.value.image.description = b;
            }
        };
        _this.validate = function (values) {
            var errors = {};
            if (!values.name) {
                errors.name = "이름을 입력하세요.";
            }
            if (!values.urlName) {
                errors.urlName = "영어 이름을 입력하세요.";
            }
            if (!values.urlName.match(/^[a-z0-9\-]*$/)) {
                errors.urlName = "영어 이름은 소문자 알파벳과 - 만 사용 가능합니다.";
            }
            return errors;
        };
        _this.registerImages = function (idx, files) {
            _this.setState(function (prevState) {
                var _a;
                return {
                    imageMap: __assign({}, prevState.imageMap, (_a = {}, _a[idx] = files, _a)),
                };
            });
            _this.touchForm();
        };
        _this.touchForm = function () {
            _this.setState({
                touched: true,
            });
        };
        _this.removeComponent = function (components, idx, e) {
            e.preventDefault();
            var imageMap = _this.state.imageMap;
            components.splice(idx, 1);
            var newImageMap = {};
            Object.entries(imageMap).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (key > idx) {
                    newImageMap[key - 1] = value;
                }
                else if (key < idx) {
                    newImageMap[key] = value;
                }
            });
            _this.setState({
                imageMap: newImageMap,
            });
            _this.touchForm();
        };
        _this.createNewComponent = function (components, type, e) {
            e.preventDefault();
            var newComponent = {
                type: type,
                id: uuid.v4(),
                value: {
                    image: null,
                    images: null,
                    list: null,
                    paragraph: null,
                    patent: null,
                    table: null,
                    title: null,
                    video: null,
                    files: null,
                },
            };
            switch (type) {
                case PageComponentType.Images: {
                    newComponent.value.title = "";
                    newComponent.value.images = [
                        {
                            url: "",
                            description: "",
                        },
                    ];
                    break;
                }
                case PageComponentType.ImageParagraph: {
                    newComponent.value.title = "";
                    newComponent.value.paragraph = "";
                    newComponent.value.image = {
                        url: "",
                        description: "",
                    };
                    break;
                }
                case PageComponentType.List: {
                    newComponent.value.title = "";
                    newComponent.value.list = [""];
                    break;
                }
                case PageComponentType.Paragraph: {
                    newComponent.value.title = "";
                    newComponent.value.paragraph = "";
                    break;
                }
                case PageComponentType.Patent: {
                    newComponent.value.title = "";
                    newComponent.value.patent = {
                        certificateImgUrl: "",
                        applicationNumber: "",
                        registrationNumber: "",
                    };
                    break;
                }
                case PageComponentType.Table: {
                    newComponent.value.title = "";
                    newComponent.value.table = {
                        rowNumber: 1,
                        columnNumber: 1,
                        rows: [
                            {
                                cells: [""],
                            },
                        ],
                    };
                    break;
                }
                case PageComponentType.Video: {
                    newComponent.value.title = "";
                    newComponent.value.video = {
                        url: "",
                        description: "",
                    };
                    break;
                }
                case PageComponentType.Files: {
                    newComponent.value.title = "";
                    newComponent.value.files = [];
                }
            }
            components.push(newComponent);
            _this.touchForm();
        };
        _this.moveToUpComponent = function (components, idx, e) {
            e.preventDefault();
            var temp = components[idx];
            components[idx] = components[idx - 1];
            components[idx - 1] = temp;
            _this.touchForm();
        };
        _this.moveToDownComponent = function (components, idx, e) {
            e.preventDefault();
            var temp = components[idx];
            components[idx] = components[idx + 1];
            components[idx + 1] = temp;
            _this.touchForm();
        };
        return _this;
    }
    Subpage.prototype.render = function () {
        var _this = this;
        var id = this.props.id;
        var touched = this.state.touched;
        return (React.createElement(Query, { query: GET_SUBPAGE, variables: { id: id }, fetchPolicy: "network-only" }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
            if (loading)
                return React.createElement(Loading, null);
            if (error || !data.subpage)
                return React.createElement(Error, { error: error });
            var _b = data.subpage, name = _b.name, urlName = _b.urlName, components = _b.components;
            components.forEach(function (component) {
                return _this.changeAToB(component, null, "");
            });
            return (React.createElement(Container, null,
                React.createElement(Formik, { initialValues: { name: name, urlName: urlName, components: components }, onSubmit: function (values, actions) {
                        _this.update(values, client).then(function () {
                            actions.setSubmitting(false);
                            actions.resetForm(values);
                        });
                    }, validate: _this.validate }, function (_a) {
                    var isSubmitting = _a.isSubmitting, dirty = _a.dirty, components = _a.values.components;
                    var submittable = dirty || touched;
                    return (React.createElement(Form, null,
                        React.createElement("div", { className: "box basic-info" },
                            React.createElement("h2", null, "\uAE30\uBCF8\uC815\uBCF4"),
                            React.createElement("div", { className: "content" },
                                React.createElement("div", { className: "input-list" },
                                    React.createElement("div", { className: "input" },
                                        React.createElement("label", { htmlFor: "name" }, "\uC774\uB984"),
                                        React.createElement(Field, { name: "name" }),
                                        React.createElement(ErrorMessage, { name: "name", render: function (msg) { return (React.createElement("div", { className: "error" }, msg)); } })),
                                    React.createElement("div", { className: "input" },
                                        React.createElement("label", { htmlFor: "urlName" }, "\uC601\uC5B4\uC774\uB984"),
                                        React.createElement(Field, { name: "urlName" }),
                                        React.createElement(ErrorMessage, { name: "urlName", render: function (msg) { return (React.createElement("div", { className: "error" }, msg)); } }))),
                                React.createElement("div", { className: "button" },
                                    React.createElement("button", { type: "submit", className: cx({ submittable: submittable }), disabled: isSubmitting || !submittable }, "\uBCC0\uACBD \uBC18\uC601\uD558\uAE30")))),
                        components.map(function (component, idx) {
                            var type = component.type;
                            var children = null;
                            var componentProps = {
                                idx: idx,
                                component: component,
                                registerImages: _this.registerImages,
                                touchForm: _this.touchForm,
                            };
                            switch (type) {
                                case PageComponentType.ImageParagraph: {
                                    children = React.createElement(ImageParagraph, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Images: {
                                    children = React.createElement(Images, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.List: {
                                    children = React.createElement(List, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Paragraph: {
                                    children = React.createElement(Paragraph, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Patent: {
                                    children = React.createElement(Patent, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Table: {
                                    children = React.createElement(Table, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Video: {
                                    children = React.createElement(Video, __assign({}, componentProps));
                                    break;
                                }
                                case PageComponentType.Files: {
                                    children = React.createElement(Files, __assign({}, componentProps));
                                    break;
                                }
                            }
                            return (React.createElement("div", { className: "box", key: component.id },
                                idx !== 0 && (React.createElement("div", { className: "up-btn", onClick: function (e) {
                                        return _this.moveToUpComponent(components, idx, e);
                                    } }, "\uC704\uB85C")),
                                idx !== components.length - 1 && (React.createElement("div", { className: "down-btn", onClick: function (e) {
                                        return _this.moveToDownComponent(components, idx, e);
                                    } }, "\uC544\uB798\uB85C")),
                                React.createElement("div", { className: "delete-btn", onClick: function (e) {
                                        return _this.removeComponent(components, idx, e);
                                    } }, "X"),
                                children));
                        }),
                        React.createElement("div", { className: "creation-box" },
                            React.createElement("div", { className: "title" }, "\uCEF4\uD3EC\uB10C\uD2B8 \uCD94\uAC00\uD558\uAE30"),
                            React.createElement("div", { className: "btns" },
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Images, e);
                                    } }, "\uC774\uBBF8\uC9C0\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.ImageParagraph, e);
                                    } }, "\uC774\uBBF8\uC9C0-\uBB38\uC7A5\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.List, e);
                                    } }, "\uBAA9\uB85D\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Paragraph, e);
                                    } }, "\uBB38\uC7A5\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Patent, e);
                                    } }, "\uD2B9\uD5C8\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Table, e);
                                    } }, "\uD45C\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Video, e);
                                    } }, "\uB3D9\uC601\uC0C1\uD615"),
                                React.createElement("button", { className: "btn", type: "button", onClick: function (e) {
                                        return _this.createNewComponent(components, PageComponentType.Files, e);
                                    } }, "\uD30C\uC77C\uD615")))));
                })));
        }));
    };
    return Subpage;
}(React.Component));
export default Subpage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
